import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "../components/Button";
import { useAuth } from "../lib/auth";
import { formatDate } from "../lib/format";

export default function Settings() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [signingOut, setSigningOut] = useState(false);

  async function handleLogout() {
    setSigningOut(true);
    try {
      await logout();
    } finally {
      navigate("/login");
    }
  }

  return (
    <div className="flex max-w-xl flex-col gap-6">
      <div>
        <h1 className="font-display text-xl tracking-display text-bright">Settings</h1>
        <p className="mt-1 text-sm text-muted">Your account.</p>
      </div>

      <section className="rounded border border-line bg-surface">
        <div className="border-b border-line px-4 py-3">
          <h2 className="font-display text-base tracking-display text-bright">Account</h2>
        </div>
        <dl className="divide-y divide-line">
          <Row label="Name" value={user?.name || "—"} />
          <Row label="Email" value={user?.email ?? "—"} mono />
          <Row label="Member since" value={formatDate(user?.created_at)} mono />
          <Row label="Account ID" value={user?.id ?? "—"} mono />
        </dl>
      </section>

      <section className="rounded border border-line bg-surface">
        <div className="border-b border-line px-4 py-3">
          <h2 className="font-display text-base tracking-display text-bright">Session</h2>
        </div>
        <div className="flex items-center justify-between px-4 py-3">
          <p className="text-sm text-muted">Sign out of this device.</p>
          <Button variant="danger" loading={signingOut} onClick={handleLogout}>
            Log out
          </Button>
        </div>
      </section>
    </div>
  );
}

function Row({ label, value, mono = false }: { label: string; value: string; mono?: boolean }) {
  return (
    <div className="flex items-baseline justify-between gap-4 px-4 py-3">
      <dt className="text-xs uppercase tracking-wide text-muted">{label}</dt>
      <dd className={mono ? "truncate font-mono text-xs text-body" : "truncate text-sm text-bright"}>
        {value}
      </dd>
    </div>
  );
}
